export default "__VITE_ASSET__CF4IP8Eg__"